import { useEffect, useState } from 'react';

/** True when running as an installed PWA (iOS standalone or display-mode: standalone). */
export function useIsStandalone() {
  const [standalone, set] = useState(() => detect());
  useEffect(() => {
    if (typeof matchMedia === 'undefined') return;
    const mq = matchMedia('(display-mode: standalone)');
    const on = () => set(detect());
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return standalone;
}
function detect() {
  if (typeof navigator === 'undefined') return false;
  const nav = navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true || (typeof matchMedia !== 'undefined' && matchMedia('(display-mode: standalone)').matches);
}
export const isIOS = () => typeof navigator !== 'undefined' && /iP(hone|ad|od)/.test(navigator.userAgent);
export const isAndroid = () => typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
